import {
  SUIVI_DEPOT_DEFAULT_FILTERS,
  SUIVI_DEPOT_FILTERS_TEXTS,
  SUIVI_DEPOT_FILTERS_VALUE_MAPPING,
  SuiviDepotFilters,
} from '@common/config';
import { useFiltersState } from '@common/hooks';
import { StateSetter } from '@common/services';
import { ResetFiltersButton } from '@common/ui';
import React from 'react';
import { ActiveFiltersText } from '../ActiveFiltersText';
import { SearchTextFilter } from '../SearchTextFilter';
import { StatutAttestationFilter } from './StatutAttestationFilter';
import { StatutDeclarationFilter } from './StatutDeclarationFilter';

export const CommonSuiviDepotFilters = ({
                                          filters,
                                          setFilters,
                                          withAttestationPartielleValue,
                                        }: SuiviDepotFiltersProps) => {
  const { hasSomeFilters, activeFiltersTexts } = useFiltersState({
    filters,
    texts: SUIVI_DEPOT_FILTERS_TEXTS,
    valueMapping: SUIVI_DEPOT_FILTERS_VALUE_MAPPING,
  });

  return (
    <div className={'flex flex-col gap-6'}>

      <div className={'flex items-center gap-6'}>

        <SearchTextFilter search={filters.search}
                          onSearchChange={(search) => setFilters((prevFilters) => ({ ...prevFilters, search }))}
                          minLength={3}
                          debounceTime={500}
                          emitIfEmpty />

        <StatutDeclarationFilter statut={filters.statutDeclaration}
                                 onStatutChange={(statutDeclaration) => setFilters((prevFilters) => ({
                                   ...prevFilters,
                                   statutDeclaration,
                                 }))} />

        <StatutAttestationFilter statut={filters.statutAttestation}
                                 withPartielleValue={withAttestationPartielleValue}
                                 onStatutChange={(statutAttestation) => setFilters((prevFilters) => ({
                                   ...prevFilters,
                                   statutAttestation,
                                 }))} />

        {(hasSomeFilters) && (
          <ResetFiltersButton onClick={() => setFilters(SUIVI_DEPOT_DEFAULT_FILTERS)} />
        )}
      </div>

      {(hasSomeFilters) && (
        <ActiveFiltersText texts={activeFiltersTexts} />
      )}
    </div>
  );
};

interface SuiviDepotFiltersProps {
  filters: SuiviDepotFilters;
  setFilters: StateSetter<SuiviDepotFilters>;
  withAttestationPartielleValue?: boolean;
}